// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"36034fbb3286926b","6449":"08ce012ccfd46bac"}[chunkId] + ".css";
};